/**
 * Analytics for the public profit calculator page.
 */

import { track } from "../analytics";

export function trackCalculatorPageView(): void {
  track("SITE:CALCULATOR_VIEWED", {
    page_kind: "calculator",
  });
}

export function trackCalculatorCtaClicked(params: { cta_location: string }): void {
  track("SITE:CALCULATOR_CTA_CLICKED", {
    cta_location: params.cta_location,
    page_kind: "calculator",
  });
}
